<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="dialog-header">
      <fa-icon [icon]="objectIcon"></fa-icon>
      <h2 ngpDialogTitle>{{ title }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    @if (formProperties.length > 0) {
      <app-dynamic-form
        [formProperties]="formProperties"
        [formGroup]="formGroup"
      ></app-dynamic-form>
    }
    @if (showSchedule && formGroup) {
      <app-algorithm-schedule
        [parent]="formGroup"
        [initialSchedule]="initialSchedule"
        [editMode]="editMode"
        [defaultIntervalMinutes]="initialIntervalMinutes"
        [initialRecurrence]="initialRecurrence"
        [initialTimezoneId]="initialTimezoneId"
      ></app-algorithm-schedule>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button size="sm" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button
      size="sm"
      variant="primary"
      [leadingIcon]="saveButtonIcon()"
      [disabled]="!isValid()"
      (click)="save()"
    >
      {{ saveButtonText() }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
